import { useTranslation } from 'react-i18next';

import { ErrorPage } from './components';
import { ERROR_PAGE_TYPES } from './consts';

/** Renders a not found error page when a user visits a page that does not exist */
export const NotFound = () => {
  const { t } = useTranslation();

  return (
    <ErrorPage
      content={t('errors.notFoundPage.content')}
      title={t('errors.notFoundPage.title')}
      type={ERROR_PAGE_TYPES.NOT_FOUND_PAGE}
    />
  );
};
